import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
    private _isServerDown = new BehaviorSubject<boolean>(false);

    get isServerDown$(): Observable<boolean> {
        return this._isServerDown.asObservable();
    }

    setServerDown(value: boolean): void {
        this._isServerDown.next(value);
    }
}
